// extracted by mini-css-extract-plugin
export var animationMarquee = "s_c";
export var container = "s_b";
export var image = "s_bf";
export var inner = "s_h";
export var label = "s_j";
export var paragraph = "s_y";
export var slash = "s_bg";
export var text = "s_S";
export var title = "s_k";